var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.538 5.47a1.627 1.627 0 0 1 0 2.274L9.958 19.529a1.56 1.56 0 0 1-2.232 0l-5.264-5.357a1.627 1.627 0 0 1 0-2.273 1.56 1.56 0 0 1 2.233 0l4.147 4.221L19.305 5.47a1.56 1.56 0 0 1 2.233 0",
    clipRule: "evenodd"
  })));
};
export default SvgCheckmark;